module.exports = __webpack_public_path__ + "stylesheets/wave-projects_8a85e6bcc0cd204cb9f3e6681b8a4451.css";


//////////////////
// WEBPACK FOOTER
// ./app/assets/stylesheets/wave/wave-projects.less
// module id = 15vf
// module chunks = 51